import styled, { keyframes } from 'styled-components';
import { media } from '@quiqupltd/qu-react-sdk/lib/styles/mixins/media';
import scrollbar from '@quiqupltd/qu-react-sdk/lib/styles/mixins/scrollbar';
import { pxToRem } from '@quiqupltd/qu-react-sdk/lib/utils/styles';
import theme from '@quiqupltd/qu-react-sdk/lib/styles/theme';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  height: ${props => {
    const { isOpen, isCustomized, isPending, isDeliveryFailed, isFinished } = props;
    if (isOpen) {
      // 70px is the height of the business logo container
      return 'calc(100% - 70px)';
    }

    if (isFinished) {
      return '300px';
    }

    if (isCustomized && (isDeliveryFailed || isPending)) {
      return '166px';
    }

    if ((!isCustomized && isDeliveryFailed) || (!isCustomized && isPending)) {
      return '176px';
    }

    return '157px';
  }};
  width: 100%;
  transition: height 0.3s;
  background-color: #fff;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${media.up('phone')`
    top: 0;
    width: 100%;
    max-width: 416px;
    height: 100%;
  `};
`;

const keyframesHorizonal = keyframes`
  0% {
    background-position: 0% 50%
  }
  100% {
    background-position: -200% 50%
  }
`;

const keyframesVertical = keyframes`
  0% {
    background-position: 50% 0%
  }
  100% {
    background-position: 50% -200%
  }
`;
const gradient = (direction = 'to left') => {
  return `linear-gradient(${direction}, ${theme.sky500}, ${theme.cornFlower500} 5%, ${theme.sky500})`;
  // return `linear-gradient(${direction}, #404693, #0ed135 5%, #404693)`
};

export const LoadingBar = styled.div`
  width: 100%;
  height: 6px;
  position: absolute;
  right: 0;
  background: ${props => (props.isCancelled ? props.theme.peach500 : gradient('to left'))};
  background-size: 200% 100%;

  animation-name: ${keyframesHorizonal};
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-delay: 0;
  animation-timing-function: ease;

  ${media.up('phone')`
    width: 6px;
    height: 100%;
    background: ${props => (props.isCancelled ? props.theme.peach500 : gradient('to top'))};
    background-size: 100% 200%;

    animation-name: ${keyframesVertical};
    animation-duration: 2.8s;
  `};
`;

LoadingBar.defaultProps = {
  isCancelled: false,
};

export const CompletedStatusBar = styled.div`
  width: 100%;
  height: 6px;
  position: absolute;
  right: 0;
  background-color: ${props => props.theme.cornFlower500};

  ${media.up('phone')`
    width: 6px;
    height: 100%;
  `};
`;

export const ScrollContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  ${scrollbar('8px')};
`;

export const Phone = styled.a`
  font-size: ${pxToRem(16)};
  font-weight: 500;
  line-height: 1.25;
  color: ${props => props.theme.sky500};
  text-decoration: none;
  user-select: all;

  &:hover {
    text-decoration: underline;
  }
`;

// general label
export const Label = styled.p`
  font-size: ${pxToRem(12)};
  text-transform: uppercase;
  font-weight: 300;
  line-height: 1.3;
  margin: 0 0 7px 0;
  color: ${props => props.theme.sky500};
`;

export const BusinessLogoContainer = styled.div`
  display: none;
  width: auto;
  height: 60px;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding-top: 10px;
  margin-bottom: 10px;

  ${media.up('phone')`
    display: flex;
  `};
`;

export const BusinessLogo = styled.img`
  max-width: 100px;
  max-height: 100%;
`;



// WEBPACK FOOTER //
// ./src/app/order-card/styles.js